import { useState } from "react";
import { AudioOutlined, PlusOutlined } from "@ant-design/icons";
import { Input, Space, Button, Card, Table, Drawer } from "antd";
import styled from "styled-components";
import PageDrawer from "./PageDrawer";
const { Search } = Input;

const onSearch = (value) => console.log(value);
const Users = () => {
  const [size, setSize] = useState("default");
  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const columns = [
    {
      title: "name",
      width: 90,
      dataIndex: "name",
      key: "name",
      fixed: "left",
    },
    {
      title: "register",
      width: 50,
      dataIndex: "register",
      key: "register",
      sorter: true,
    },
    {
      title: "status",
      width: 60,
      dataIndex: "status",
      key: "1",
    },
    {
      title: "unique link",
      width: 60,
      dataIndex: "link",
      key: "2",
    },
    {
      title: "edit",
      width: 60,
      dataIndex: "edit",
      key: "4",
    },
    {
      title: "action",
      width: 80,
      dataIndex: "action",
      key: "5",
    },
  ];
  const data = [
    {
      key: "1",
      name: "John Brown",
      register: "22/10/16 - 12:17:35",
      server_code: 183038,
      expire: <Button type="primary">Extend</Button>,
      user: (
        <Button type="primary" danger icon={<PlusOutlined />} size={size}>
          Assign To User
        </Button>
      ),
      edit: <Button type="primary">Edit</Button>,
      action: (
        <Button type="primary" danger>
          Delete
        </Button>
      ),
    },
    {
      key: "1",
      name: "John Brown",
      register: "22/10/16 - 12:17:35",
      server_code: 183038,
      expire: <Button type="primary">Extend</Button>,
      user: (
        <Button type="primary" danger icon={<PlusOutlined />} size={size}>
          Assign To User
        </Button>
      ),
      edit: <Button type="primary">Edit</Button>,
      action: (
        <Button type="primary" danger>
          Delete
        </Button>
      ),
    },
    {
      key: "1",
      name: "John Brown",
      register: "22/10/16 - 12:17:35",
      server_code: 183038,
      expire: <Button type="primary">Extend</Button>,
      user: (
        <Button type="primary" danger icon={<PlusOutlined />} size={size}>
          Assign To User
        </Button>
      ),
      edit: <Button type="primary">Edit</Button>,
      action: (
        <Button type="primary" danger>
          Delete
        </Button>
      ),
    },
    {
      key: "1",
      name: "John Brown",
      register: "22/10/16 - 12:17:35",
      server_code: 183038,
      expire: <Button type="primary">Extend</Button>,
      user: (
        <Button type="primary" danger icon={<PlusOutlined />} size={size}>
          Assign To User
        </Button>
      ),
      edit: <Button type="primary">Edit</Button>,
      action: (
        <Button type="primary" danger>
          Delete
        </Button>
      ),
    },
    {
      key: "1",
      name: "John Brown",
      register: "22/10/16 - 12:17:35",
      server_code: 183038,
      expire: <Button type="primary">Extend</Button>,
      user: (
        <Button type="primary" danger icon={<PlusOutlined />} size={size}>
          Assign To User
        </Button>
      ),
      edit: <Button type="primary">Edit</Button>,
      action: (
        <Button type="primary" danger>
          Delete
        </Button>
      ),
    },
  ];

  const suffix = (
    <AudioOutlined
      style={{
        fontSize: 16,
        color: "#1890ff",
      }}
    />
  );

  const TopD = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0px 20px;
    margin-top: -17px;
  `;

  return (
    <div className="site-card-border-less-wrapper">
      <TopD>
        <p>user list : 0</p>
        <Space direction="vertical">
          <Search
            placeholder="name or link..."
            onSearch={onSearch}
            style={{
              width: 200,
            }}
          />
        </Space>
        <PageDrawer />
      </TopD>
      <Card style={{ border: "none" }}>
        <Table
          dataSource={[]}
          columns={columns}
          scroll={{
            y: 285,
          }}
          bordered
        />
      </Card>
    </div>
  );
};

export default Users;
